'use client';

import GoogleIcon from '@/assets/icons/login&signup/google-icon.svg?url';

import { useAppDispatch } from '@/lib/hooks';
import { usersApi, useThirdLoginMutation } from '@/lib/users/usersAPI';
import { setFirebaseError } from '@/lib/users/userSlice';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { useRouter, useParams } from 'next/navigation';
import React from 'react';
import Image from 'next/image';
import { setToken } from '@/utils/setToken';
import auth from '../../../firebase';

const GoogleLoginButton = () => {
  const params = useParams();
  const { lang } = params;
  const dispatch = useAppDispatch();
  const router = useRouter();

  const [thirdLogin] = useThirdLoginMutation();

  const handleGoogleLogin = async () => {
    try {
      dispatch(setFirebaseError('')); // clear firebaseError message
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);

      // Get the ID token
      const idToken = await result.user.getIdToken();

      const thirdResult = await thirdLogin({
        accessToken: idToken,
      });

      const { isNewRegister, token, refreshToken } = thirdResult.data;
      if (token) {
        setToken(token, refreshToken);
      }
      if (isNewRegister) {
        router.push(`/${lang}/signup/profile`);
      } else {
        dispatch(usersApi.endpoints.SelfProfile.initiate({}));
      }
    } catch (error) {
      const errorCode = error.code;
      if (errorCode === 'auth/account-exists-with-different-credential') {
        dispatch(
          setFirebaseError(
            'You have already registered with a different auth provider for that email.',
          ),
        );
      } else {
        dispatch(setFirebaseError('An error occurred. Please try again.'));
      }
    }
  };

  return (
    <button
      type="button"
      onClick={handleGoogleLogin}
      className="typo-paragraph-xl flex w-fit items-center justify-center gap-1 rounded-[46px] border-1 border-primary-900 px-4 py-[10px] hover:shadow-[0_0_999px_0_#0008210A_inset] md:px-[32px] md:py-[27px]"
    >
      <Image
        src={GoogleIcon}
        alt="Google third party login"
        width={36}
        height={36}
        priority
        className="aspect-square"
      />
      Continue with Google
    </button>
  );
};

export default GoogleLoginButton;
